import { render, staticRenderFns } from "./presupuestos.vue?vue&type=template&id=c5c680e4&"
import script from "./presupuestos.vue?vue&type=script&lang=js&"
export * from "./presupuestos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports